import { render } from "./Gotop.vue?vue&type=template&id=95b252e4"
import script from "./Gotop.vue?vue&type=script&lang=js"
export * from "./Gotop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__